module.exports = __webpack_public_path__ + "static/media/search.5f20c327.svg";